export default {
  namespaced: true,

  state: {
    // تب اول
    pageFilter: 1,
    statusFilter: "all",
    typeFilter: "all",
    searchTypeFilter: {
      text: "",
      type: "search",
    },
    identifierFilter: "",
    idSearchFilter: "",
    sortFilter: "desc",
    userFilter: null,
    perPageFilter: 10,
    expireTypeFilter: {
      expired_type: "",
      days: null,
    },
    hasError: false,
    createQrID: null,
    alllangs: [],
    defaultLang: "fa",
    currentlanguage: "fa",
    mainData: null,
    qrType: null,

    // تب دوم
    pageFiltergroup: 1,
    statusFiltergroup: "all",
    typeFiltergroup: "all",
    searchTypeFiltergroup: { text: "", type: "search" },
    perPageFiltergroup: "10",
    sortFiltergroup: "desc",
    userFiltergroup: null,
    identifierFiltergroup: "",
    idSearchFiltergroup: "",
    expireTypeFiltergroup: {
      expired_type: "",
      days: null,
    },
    hasErrorgroup: false,
    registerOnline: false,
  },

  getters: {
    mainDatalang: (state) => state.mainData,
    currentlanguage: (state) => state.currentlanguage,
    // تب اول
    pageFilter: (state) => state.pageFilter,
    statusFilter: (state) => state.statusFilter,
    typeFilter: (state) => state.typeFilter,
    searchTypeFilter: (state) => state.searchTypeFilter,
    perPageFilter: (state) => state.perPageFilter,
    sortFilter: (state) => state.sortFilter,
    userFilter: (state) => state.userFilter,
    identifierFilter: (state) => state.identifierFilter,
    idSearchFilter: (state) => state.idSearchFilter,
    expireTypeFilter: (state) => state.expireTypeFilter,
    hasError: (state) => state.hasError,
    hasFilter: (state) =>
      !!(
        state.statusFilter !== "all" ||
        state.typeFilter !== "all" ||
        state.searchTypeFilter.text ||
        state.searchTypeFilter?.text?.length >= 3 ||
        state.sortFilter !== "desc" ||
        state.userFilter ||
        state.expireTypeFilter?.days ||
        state.identifierFilter ||
        state.idSearchFilter ||
        state.perPageFilter != 10
      ),

    // تب دوم
    pageFiltergroup: (state) => state.pageFiltergroup,
    statusFiltergroup: (state) => state.statusFiltergroup,
    typeFiltergroup: (state) => state.typeFiltergroup,
    searchTypeFiltergroup: (state) => state.searchTypeFiltergroup,
    perPageFiltergroup: (state) => state.perPageFiltergroup,
    sortFiltergroup: (state) => state.sortFiltergroup,
    userFiltergroup: (state) => state.userFiltergroup,
    identifierFiltergroup: (state) => state.identifierFiltergroup,
    idSearchFiltergroup: (state) => state.idSearchFiltergroup,
    expireTypeFiltergroup: (state) => state.expireTypeFiltergroup,
    hasErrorgroup: (state) => state.hasErrorgroup,

    hasFiltergroup: (state) => {
      return !!(
        state.statusFiltergroup !== "all" ||
        state.typeFiltergroup !== "all" ||
        state.searchTypeFiltergroup?.text ||
        state.searchTypeFiltergroup?.text?.length >= 3 ||
        state.sortFiltergroup !== "desc" ||
        state.identifierFiltergroup ||
        state.perPageFiltergroup != 10 ||
        state.idSearchFiltergroup ||
        state.userFiltergroup
      );
    },
    //     !==false && (state.statusFiltergroup !== "all" ||
    //     state.typeFiltergroup !== "all" ||
    //     state.searchTypeFiltergroup?.text ||
    //     state.identifierFiltergroup ||
    //     state.idSearchFiltergroup ||
    //     state.userFiltergroup)!=="");
    // },

    
    // statusFilter: (state) => state.statusFilter,
    // typeFilter: (state) => state.typeFilter,
    // searchTypeFilter: (state) => state.searchTypeFilter,
    // identifierFilter: (state) => state.identifierFilter,
    // idSearchFilter: (state) => state.idSearchFilter,
    // sortFilter: (state) => state.sortFilter,
    // userFilter: (state) => state.userFilter,
    // expireTypeFilter: (state) => state.expireTypeFilter,
    // perPageFilter: (state) => state.perPageFilter,
    createQrID: (state) => state.createQrID,
    alllangs: (state) => state.alllangs,
    defaultLang: (state) => state.defaultLang,
    qrType: (state) => state.qrType,
    registerOnline: (state) => state.registerOnline,
  },

  mutations: {
    set_register_online(state, input) {
      state.registerOnline = input;
    },
    // تب اول
    updatePageFilter(state, page) {
      state.pageFilter = Number(page) || 1;
    },
    updateStatusFilter(state, status) {
      state.statusFilter = status || "all";
    },
    updateTypeFilter(state, type) {
      state.typeFilter = type || "all";
    },
    updateSearchTypeFilter(state, searchType) {
      state.searchTypeFilter = {
        text: searchType?.text || "",
        type: searchType?.type || "search",
      };
    },
    updatePerPageFilter(state, perPage) {
      state.perPageFilter = perPage || "10";
    },
    updateSortFilter(state, sort) {
      state.sortFilter = sort || "desc";
    },
    updateUserFilter(state, user) {
      state.userFilter = user || null;
    },
    updateIdentifierFilter(state, identifier) {
      state.identifierFilter = identifier || "";
    },
    updateIdSearchFilter(state, idSearch) {
      state.idSearchFilter = idSearch || "";
    },
    updateExpireTypeFilter(state, expireType) {
      state.expireTypeFilter = expireType || "";
    },
    updateHasError(state, error) {
      state.hasError = Boolean(error);
    },

    reset(state) {
      state.statusFilter = "all";
      state.typeFilter = "all";
      state.searchTypeFilter = {
        text: "",
        type: "search",
      };
      state.sortFilter = "desc";
      state.userFilter = null;
      state.perPageFilter = "10";
      state.identifierFilter = "";
      state.idSearchFilter = "";
      state.pageFilter = 1;
      state.expireTypeFilter = { expired_type: "", days: null };
      (state.scrollPosition = 0), (state.hasError = false);
      sessionStorage.setItem("qrListState", JSON.stringify(state));
      sessionStorage.removeItem("qrListState");
    },

    // تب دوم
    updatePageFiltergroup(state, page) {
      state.pageFiltergroup = Number(page) || 1;
    },
    updateStatusFiltergroup(state, status) {
      state.statusFiltergroup = status || "all";
    },
    updateTypeFiltergroup(state, type) {
      state.typeFiltergroup = type || "all";
    },
    updateSearchTypeFiltergroup(state, searchType) {
      state.searchTypeFiltergroup = {
        text: searchType?.text || "",
        type: searchType?.type || "search",
      };
    },
    updatePerPageFiltergroup(state, perPage) {
      state.perPageFiltergroup = Number(perPage) || 10;
    },
    updateSortFiltergroup(state, sort) {
      state.sortFiltergroup = sort || "desc";
    },
    updateUserFiltergroup(state, user) {
      state.userFiltergroup = user || null;
    },
    updateIdentifierFiltergroup(state, identifier) {
      state.identifierFiltergroup = identifier || "";
    },
    updateIdSearchFiltergroup(state, idSearch) {
      state.idSearchFiltergroup = idSearch || "";
    },
    updateExpireTypeFiltergroup(state, expireType) {
      state.expireTypeFiltergroup = expireType || "";
    },
    updateHasErrorgroup(state, error) {
      state.hasErrorgroup = Boolean(error);
    },
    resetGroup(state) {
      state.pageFiltergroup = 1;
      state.statusFiltergroup = "all";
      state.typeFiltergroup = "all";
      state.searchTypeFiltergroup = { text: "", type: "search" };
      state.sortFiltergroup = "desc";
      state.userFiltergroup = null;
      state.perPageFiltergroup = "10";
      state.identifierFiltergroup = "";
      state.idSearchFiltergroup = "";
      state.expireTypeFiltergroup = { expired_type: "", days: null };
      state.hasErrorgroup = false;
      sessionStorage.setItem("qrListStateGroup", JSON.stringify(state));
      sessionStorage.removeItem("qrListStateGroup");
    },
    // updatePageFilter(state, value) {
    //   state.pageFilter = value;
    // },
    // updatePageFiltergroup(state, value) {
    //   state.pageFiltergroup = value;
    // },
    updateStatus(state, input) {
      state.statusFilter = input;
    },
    updateStatusgroup(state, input) {
      state.statusFiltergroup = input;
    },
    updateType(state, input) {
      state.typeFilter = input;
    },
    updateTypegroup(state, input) {
      state.typeFiltergroup = input;
    },
    updateSearch(state, input) {
      state.searchTypeFilter = input;
    },
    updateIdentifier(state, input) {
      state.identifierFilter = input;
    },
    updateIdSearch(state, input) {
      state.idSearchFilter = input;
    },
    updateSort(state, input) {
      state.sortFilter = input;
    },
    updateUser(state, input) {
      state.userFilter = input;
    },
    updateExpireType(state, input) {
      state.expireTypeFilter = input;
    },
    updatePerPage(state, input) {
      state.perPageFilter = input;
    },
    updatePerPagegroup(state, input) {
      state.perPageFiltergroup = input;
    },
    updateHasError(state, input) {
      state.hasError = input;
    },
    updateHasErrorgroup(state, input) {
      state.hasErrorgroup = input;
    },
    set_created_qrID(state, input) {
      state.createQrID = input;
    },
    set_lang_list(state, input) {
      state.alllangs = input;
    },
    set_default_lang(state, input) {
      state.defaultLang = input;
    },
    set_current_language(state, input) {
      state.currentlanguage = input;
    },
    set_qr_type(state, input) {
      state.qrType = input;
    },
    set_main_data(state, input) {
      state.mainData = input;
    },
    updatePerPageFilter(state, value) {
      state.perPageFilter = value;
    },
    updatePerPageFiltergroup(state, value) {
      state.perPageFiltergroup = value;
    },
    updateSortFilter(state, value) {
      state.sortFilter = value;
    },
    updateSortFilter(state, value) {
      state.sortFilter = value;
    },
    updateStatusFilter(state, value) {
      state.statusFilter = value;
    },
    updateTypeFilter(state, value) {
      state.typeFilter = value;
    },
    updateSearchTypeFilter(state, value) {
      state.searchTypeFilter = value;
    },
  },

  actions: {
    updatePageFilter({ commit }, value) {
      commit("updatePageFilter", value);
    },
    updatePageFiltergroup({ commit }, value) {
      commit("updatePageFiltergroup", value);
    },
    updateStatusFilter({ commit }, input) {
      commit("updateStatus", input);
    },
    updateStatusFiltergroup({ commit }, input) {
      commit("updateStatusgroup", input);
    },
    updateTypeFilter({ commit }, input) {
      commit("updateType", input);
    },
    updateTypeFiltergroup({ commit }, input) {
      commit("updateTypegroup", input);
    },
    updateSearchTypeFilter({ commit }, input) {
      commit("updateSearch", input);
    },
    updateSearchTypeFiltergroup({ commit }, input) {
      commit("updateSearchgroup", input);
    },
    updateIdentifierFilter({ commit }, input) {
      commit("updateIdentifier", input);
    },
    updateIdSearchFilter({ commit }, input) {
      commit("updateIdSearch", input);
    },
    updateSortFilter({ commit }, input) {
      commit("updateSort", input);
    },
    updateUserFilter({ commit }, input) {
      commit("updateUser", input);
    },
    updateExpireTypeFilter({ commit }, input) {
      commit("updateExpireType", input);
    },
    updatePerPageFilter({ commit }, input) {
      commit("updatePerPage", input);
    },
    updatePerPageFiltergroup({ commit }, input) {
      commit("updatePerPagegroup", input);
    },
    resetStates({ commit }) {
      commit("reset");
    },
    resetStatesGroup({ commit }) {
      commit("resetGroup");
    },
    updateHasError({ commit }, input) {
      commit("updateHasError", input);
    },
    updateHasErrorgroup({ commit }, input) {
      commit("updateHasErrorgroup", input);
    },
    setCreatedQrID({ commit }, input) {
      commit("set_created_qrID", input);
    },
    setLangList({ commit }, input) {
      commit("set_lang_list", input);
    },
    setDefaultLang({ commit }, input) {
      commit("set_default_lang", input);
    },
    setCurrentLanguage({ commit }, input) {
      commit("set_current_language", input);
    },
    setQrType({ commit }, input) {
      commit("set_qr_type", input);
    },
    setRegisterOnline({ commit }, input) {
      commit("set_register_online", input);
    },
    setMainData({ commit }, input) {
      commit("set_main_data", input);
    },
  },
};
